var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"privacy-policy"},[_c('p',{staticClass:"tac fw fs16px"},[_vm._v("方田教育隐私政策")]),_vm._l((_vm.ppList),function(item,index){return _c('p',{key:index,class:{'fw': item.fw}},[_vm._v(_vm._s(item.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }